function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 12.527344 9.5625 C 12.550781 12.285156 14.972656 13.191406 15 13.203125 C 14.976562 13.269531 14.613281 14.496094 13.722656 15.765625 C 12.957031 16.863281 12.160156 17.953125 10.90625 17.976562 C 9.671875 18 9.273438 17.261719 7.863281 17.261719 C 6.457031 17.261719 6.015625 17.953125 4.847656 18 C 3.636719 18.042969 2.714844 16.8125 1.9375 15.71875 C 0.355469 13.484375 -0.851562 9.40625 0.773438 6.652344 C 1.578125 5.285156 3.019531 4.417969 4.582031 4.394531 C 5.773438 4.375 6.894531 5.175781 7.621094 5.175781 C 8.347656 5.175781 9.714844 4.210938 11.148438 4.351562 C 11.75 4.375 13.433594 4.589844 14.515625 6.136719 C 14.429688 6.191406 12.503906 7.285156 12.527344 9.5625 M 10.207031 2.875 C 10.851562 2.113281 11.285156 1.054688 11.167969 0 C 10.238281 0.0351562 9.117188 0.605469 8.453125 1.363281 C 7.859375 2.039062 7.335938 3.117188 7.476562 4.148438 C 8.511719 4.226562 9.566406 3.636719 10.207031 2.875 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleBlackIcon);
export default __webpack_public_path__ + "static/media/apple-black-icon.aa2fd2a8cd278cacb352571ab5cf8b78.svg";
export { ForwardRef as ReactComponent };